// App runtime config
export const Loading = 'loading';
export const NOTIFICATION_TIMEOUT = 1000;
/** HTTP request timeout per call. Matches mobile SERVER_RESPONSE_TIMEOUT_IN_MS. */
export const API_REQUEST_TIMEOUT_MS = 5 * 60 * 1000; // 5 minutes
export const ID_SEPARATOR = ':';

// ── React Query cache lifetimes ───────────────────────────────────────────────

/** How long cached data is considered fresh before a background refetch is triggered. */
export const QUERY_STALE_TIME_MS = 5 * 60 * 1000; // 5 minutes

/** How long inactive (unsubscribed) cache entries remain in memory before garbage collection. */
export const QUERY_GC_TIME_MS = 5 * 60 * 1000; // 5 minutes

/** Maximum number of retries for transient errors (network, 408, 429, 5xx). */
export const QUERY_MAX_RETRIES = 3;

/**
 * Extended gcTime for high-value cache entries that benefit from a longer
 * in-memory lifetime (e.g. user profile — avoids a refetch when the user
 * navigates away and returns within a normal session).
 */
export const QUERY_GC_TIME_LONG_MS = 60 * 60 * 1000; // 60 minutes
export const EMPTY_GUID = '00000000-0000-0000-0000-000000000000';

// Pagination
export const DEFAULT_PAGE_SIZE = 50;
export const SUBROW_PAGINATION_DEFAULT_PAGE_SIZE = 25;
export const DEFAULT_PAGE_INDEX = 1;
export const M_CROPS_FETCH_PAGE_SIZE = 100;
export const STEP_CATALOGUE_GC_PAGE_SIZE = 100;

// Debounce
export const INPUT_DOCUMENT_SAVE_DEBOUNCE_MS = 3000;
